/**
 * SearchBar Component
 * Search input with icon
 * Matches Flutter implementation: lib/presentation/bottom_sheet/search_users_bottom_sheet.dart - appBarTitle
 */

import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { AssetIcon } from '@/presentation/components/common/icon/AssetIcon';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Optional `data-qa-*` set for the search `<input>` so the qa-tester can locate it. */
  qa?: QaAttrOptions;
}

export const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder, qa }) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: responsive.spacing.lg,
      }}
    >
      <div style={{ marginRight: responsive.spacing.sm }}>
        <AssetIcon path="/assets/images/search.png" width={responsive.button.size.xxs} height={responsive.button.size.xxs} />
      </div>

      <style>
        {`
          .search-input::placeholder {
            color: ${theme.text.primary};
          }
        `}
      </style>
      <input
        {...(qa ? qaAttr(qa) : {})}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="search-input"
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          fontSize: responsive.font.base,
          color: theme.text.primary,
          backgroundColor: 'transparent',
        }}
      />
    </div>
  );
};
